import { render, staticRenderFns } from "./prestoreAccount.vue?vue&type=template&id=c8be1eae&scoped=true"
import script from "./prestoreAccount.vue?vue&type=script&lang=js"
export * from "./prestoreAccount.vue?vue&type=script&lang=js"
import style0 from "./prestoreAccount.vue?vue&type=style&index=0&id=c8be1eae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8be1eae",
  null
  
)

export default component.exports